'use client';
import { useState, useEffect } from 'react';
import Image from 'next/image';
import workingImage from '/public/workingonpcformodal.webp';
import { Roboto } from 'next/font/google';
import { incrementCount } from '@/utils/api';

const roboto = Roboto({
  subsets: ['latin'],
  weight: ['400', '700'],
});

const WelcomeModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const hasSeenModal = sessionStorage.getItem('hasSeenModal');
    if (!hasSeenModal) setIsModalOpen(true);
  }, []);

  const closeModal = async () => {
    try {
      setIsModalOpen(false);
      await incrementCount();
      sessionStorage.setItem('hasSeenModal', 'true');
    } catch (error) {
      console.error('Error while closing modal:', error);
    }
  };

  if (!isModalOpen) return null;

  return (
    <div className='fixed inset-0 bg-black/90 backdrop-blur-sm flex items-center justify-center z-[999]'>
      <div
        className={`relative bg-gradient-to-br from-blue-900 via-purple-900 to-indigo-900 p-8 rounded-2xl shadow-2xl max-w-2xl mx-4 border border-white/10 ${roboto.className}`}
      >
        {/* Floating particles background */}
        <div className='absolute inset-0 overflow-hidden rounded-2xl'>
          {[...Array(12)].map((_, i) => (
            <div
              key={i}
              className='absolute animate-float'
              style={{
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
                width: '2px',
                height: '2px',
                backgroundColor: '#fff',
                borderRadius: '50%',
                opacity: 0.3,
                animationDelay: `${i * 0.5}s`,
              }}
            />
          ))}
        </div>

        {/* Content container */}
        <div className='relative z-10 flex flex-col items-center space-y-6'>
          {/* Image with gradient border */}
          <div className='relative rounded-lg p-1 bg-gradient-to-r from-blue-400 to-purple-300'>
            <div className='relative overflow-hidden rounded-lg border-2 border-white/10'>
              <Image
                src={workingImage}
                alt='Working on PC'
                width={160}
                height={160}
                className='object-cover'
                priority
              />
            </div>
          </div>

          {/* Text content */}
          <div className='space-y-4 text-center'>
            <h2 className='text-3xl md:text-4xl font-bold bg-gradient-to-r from-blue-300 to-purple-200 bg-clip-text text-transparent'>
              Welcome ,Hope you doing well ! 🚀
            </h2>
            <p className='text-gray-200/90 leading-relaxed text-lg'>
              Thanks for stopping by! I'm currently polishing my portfolio to
              make it even better. If you notice anything that needs fixing or
              have suggestions, I'd love to hear from you through the contact
              form!
            </p>
          </div>

          {/* Animated button */}
          <button
            onClick={closeModal}
            className='group relative px-8 py-3 rounded-full bg-gradient-to-r from-blue-500 to-purple-400 hover:from-blue-400 hover:to-purple-300 transition-all duration-300 shadow-lg hover:shadow-xl'
          >
            <span className='text-white font-semibold text-lg tracking-wide'>
              Let's Explore!
            </span>
            <span className='ml-2 opacity-80 group-hover:opacity-100 transition-opacity'>
              🎉
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;
